import React from 'react';
import { Alert, Card, Badge } from 'react-bootstrap';
import {
  SELECTABLE_DOC_TYPES, DOC_TYPE_META, DOC_TYPES, isLiveDocument,
} from '../../Utils/billingoDocuments';

// Step 1 — choose which Hungarian document to issue. Shows the issue-order
// chain for context, what is already issued of each type, and flags the
// flow's `recommended` type (recommendedDocType — null once the order is
// finally invoiced).
function BillingoDocumentTypePicker({
  value = null, onChange, recommended = null, existingDocs = [],
}) {
  const issued = (type) => existingDocs
    .filter((d) => d.type === type && isLiveDocument(d))
    .map((d) => d.number);

  return (
    <div>
      <p className="text-muted">
        Documents are issued in sequence. Díjbekérő is optional — not every order needs one.
      </p>

      {!recommended && (
        <Alert variant="warning" className="py-2 small">
          <i className="fa fa-triangle-exclamation me-2" />
          This order already has its final invoice. Another document would invoice it
          twice — check the documents already issued before going on.
        </Alert>
      )}

      <div className="d-flex align-items-center justify-content-center flex-wrap gap-2 mb-4 small text-muted">
        <span>{DOC_TYPE_META[DOC_TYPES.DIJBEKERO].hu}</span>
        <i className="fa fa-arrow-right" />
        <span>{DOC_TYPE_META[DOC_TYPES.ELOLEGSZAMLA].hu}</span>
        <i className="fa fa-arrow-right" />
        <span>{DOC_TYPE_META[DOC_TYPES.SZAMLA].hu}</span>
      </div>

      <div className="d-flex flex-column gap-2">
        {SELECTABLE_DOC_TYPES.map((type) => {
          const meta = DOC_TYPE_META[type];
          const selected = value === type;
          return (
            <Card
              key={type}
              role="button"
              onClick={() => onChange(type)}
              border={selected ? 'primary' : undefined}
              className={selected ? 'shadow-sm' : ''}
            >
              <Card.Body className="d-flex align-items-center justify-content-between py-3">
                <div className="d-flex align-items-center gap-3">
                  <input
                    type="radio"
                    name="billingo-doc-type"
                    checked={selected}
                    onChange={() => onChange(type)}
                    aria-label={meta.hu}
                  />
                  <div>
                    <div className="fw-semibold">
                      {meta.hu}
                      {type === recommended && (
                        <Badge bg="primary" className="ms-2">Recommended</Badge>
                      )}
                    </div>
                    <div className="text-muted small">{meta.en}</div>
                    {issued(type).length > 0 && (
                      <div className="small text-warning-emphasis">
                        {`Already issued: ${issued(type).join(', ')}`}
                      </div>
                    )}
                  </div>
                </div>
                <Badge bg={meta.variant} text={meta.variant === 'light' ? 'dark' : undefined}>
                  {meta.billingoBlock}
                </Badge>
              </Card.Body>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

export default BillingoDocumentTypePicker;
